import { useState } from 'react';

const useSelectionMarqueeList = () => {
    const [selectionMarqueeActive, setSelectionMarqueeActive] = useState(false);
    const [listContainerNode, setListContainerNode] = useState(null);

    return {
        selectionMarqueeActive,
        setSelectionMarqueeActive,
        listContainerNode,
        setListContainerNode,
    };
};

export default useSelectionMarqueeList;
